<template>
  <div class="a-spinner" :class="['a-spinner-' + size, 'a-spinner-' + theme]">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
  export default {
    props: {
      size: {
        type: String,
        default: 'S' // L, M, S, XS
      },
      theme: {
        type: String,
        default: 'dark'
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/c-spinner.vue